module.exports = __webpack_public_path__ + "media/loketpendaftaran3.d7807998.mp3";